import styled from 'styled-components';

export const Title = styled.h1`
  color: #f1f1f1;
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
`;

export const InterestContainer = styled.div`
  position: absolute;
  top: 50%;
  bottom: 0;
  left: 50%;
  right: 0;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  justify-content: center;

  width: 50vw;
  height: 60vh;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);

  @media (max-width: 768px) {
    width: 80vw;
    top: 5%;
    bottom: unset;
    left: 0;
    margin: auto;
    right: 0;
    transform: none;
    padding: 1rem;
    height: auto;
  }
`;
export const Tags = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const OneTag = styled.label`
  font-weight: 500;
  font-size: 22px;
`;

export const TagName = styled.span`
  color: #404040;
  font-size: 15px;
  line-height: 1.2rem;
  text-align: center;
  display: inline-block;
  width: max-content;
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 20px;
  margin-right: 10px;
  margin-bottom: 13px;
  padding: 0.25rem 1rem;
  font-weight: 500;
  transition: all 0.3s linear;
`;

export const CheckBox = styled.input`
  border: none;
  outline: none;
  display: none;
  &:checked + ${TagName} {
    background-color: #4fd8e0;
    color: #ffffff;
    outline: 0;
    border: 1px solid #4fd8e0;
  }
`;

export const Button = styled.button`
  height: 50px;
  width: 150px;
  border-radius: 10px;
  background-color: #000;
  color: #f1f1f1;
  font-weight: 500;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s linear;
  &:disabled {
    opacity: 0.5;
  }
`;
